// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { SchemaModifier } from '../types';
import { generateSchema } from '../SchemaGeneration';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

const continuingEducationModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.continuing_education_type) {
    main['educationalProgramMode'] = normalizeContent(
      content?.continuing_education_type,
      true,
    );
  }
  if (content?.cost_absorption) {
    main['financialAidEligible'] = (
      normalizeContent(content.cost_absorption, true) as string[]
    ).join(', ');
  }
  if (content?.target_audience) {
    main['audience'] = (
      normalizeContent(content.target_audience, true) as string[]
    ).join(', ');
  }
  const programs: Content[] = [
    ...(content?.mandatory_programs || []),
    ...(content?.elective_programs || []),
    ...(content?.elective_mandatory_programs || []),
  ];
  if (programs.length > 0) {
    main['hasPart'] = programs.map((program) => {
      return generateSchema({
        type: program['@type'] || 'Course',
        content: program,
        state,
        partial: true,
      });
    });
  }
};

export default continuingEducationModifier;
